<nav class="navbar sticky-top border" style="background-color: #f6e9da">
    <div class="container">
        <a class="navbar-brand" routerLink="/"
            ><img id="navImage" [class.reduceImage]="windowScrolled" src="/assets/rs-logo.jpg" style="width: 222px"
        /></a>
        <div class="me-3 ms-auto">
            <div class="d-inline me-1">
                <a
                    [routerLink]="['/rss']"
                    class="btn text-white shadow-lg"
                    style="background-color: #fd7e14; font-weight: 500; font-size: 16px"
                >
                    Join Rss</a
                >
            </div>
            <div class="d-inline">
                <a
                    [routerLink]="['/joinstudents']"
                    class="btn text-white shadow-lg"
                    style="background-color: #fd7e14; font-weight: 500; font-size: 16px"
                >
                    Student Registration</a
                >
            </div>
        </div>
        <button
            class="border-0"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNavbar"
            aria-controls="offcanvasNavbar"
            style="background-color: #f6e9da"
        >
            <i class="fa fa-bars" aria-hidden="true" style="color: #eb690d; font-size: 20px"></i>
        </button>

        <div
            class="offcanvas offcanvas-end"
            tabindex="-1"
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
            style="background-color: #f6e9da"
        >
            <div class="offcanvas-header">
                <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div class="offcanvas-body">
                <ul class="navbar-nav justify-content-end flex-grow-1 pe-3">
                    <li class="nav-item dropdown" style="color: #eb690d">
                        <a
                            class="nav-link dropdown-toggle"
                            href="#"
                            id="navbarScrollingDropdown"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style="color: #eb690d; font-size: 14px; font-weight: 700"
                        >
                            Kshetras
                        </a>
                        <div class="dropdown-menu border-0" aria-labelledby="navbarDropdown" style="background-color: #f6e9da">
                            <a
                                *ngFor="let department of departments"
                                class="dropdown-item"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasNavbar"
                                [routerLink]="['/department', department?.id]"
                                style="color: #eeab6e; font-size: 14px; font-weight: 700"
                                >{{ department.name }}</a
                            >
                        </div>
                    </li>
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            routerLink="team"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasNavbar"
                            [routerLink]="['/team']"
                            style="color: #eb690d; font-size: 14px; font-weight: 700"
                            >Team</a
                        >
                    </li>
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            routerLink="event"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasNavbar"
                            [routerLink]="['/event']"
                            style="color: #eb690d; font-size: 14px; font-weight: 700"
                            >Events</a
                        >
                    </li>
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            routerLink="gallery"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasNavbar"
                            [routerLink]="['/gallery']"
                            style="color: #eb690d; font-size: 14px; font-weight: 700"
                            >Gallery</a
                        >
                    </li>
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            routerLink="announcements"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasNavbar"
                            [routerLink]="['/announcements']"
                            style="color: #eb690d; font-size: 14px; font-weight: 700"
                            >Announcements</a
                        >
                    </li>

                    <li class="nav-item">
                        <a
                            class="nav-link"
                            routerLink="Contact Us"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasNavbar"
                            [routerLink]="['/Contact Us']"
                            style="color: #eb690d; font-size: 14px; font-weight: 700"
                            >Contact Us</a
                        >
                    </li>
                </ul>
            </div>
        </div>
    </div>
</nav>
